<template>
  <el-select
    :value="value"
    size="small"
    filterable
    @change="handleChange"
    @blur="handleBlur"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    ref="itemSelect"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { CommodityCategoryMap } from '@/config/global'

export default {
  props: {
    value: '',
  },
  data() {
    return {
      lists: CommodityCategoryMap,
      loading: false,
    }
  },
  created() {
    // if (this.value) {
    //   this.requestData('', this.value)
    // }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    handleBlur() {
      setTimeout(() => {
        this.$emit('blur', this.value)
      }, 100)
    },
    // async requestData(query, defaultValue = 0) {
    //   if (query !== '' || defaultValue) {
    //     this.loading = true
    //     let data = {
    //       query: query,
    //       id: defaultValue,
    //       category: this.category,
    //       size: 20,
    //     }
    //     let res = await commodityList(data)
    //     this.loading = false
    //     this.lists = res.data.list
    //   } else {
    //     this.lists = []
    //   }
    // },
  },
}
</script>